import { render, staticRenderFns } from "./ContentBlockSeparator.vue?vue&type=template&id=52bb1680&"
import script from "./ContentBlockSeparator.vue?vue&type=script&lang=js&"
export * from "./ContentBlockSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports